// Catalogo unico de modulos del Hub y sidebar contextual (v37.0).
// Agregar modulo nuevo = un objeto mas + crear ruta en App.js + crear pagina.
// estados: 'activo' | 'admin' | 'desarrollo'
//
// rol: 'rrhh' (v49) — el modulo entero solo se muestra a miembros del grupo
// RRHH de Azure AD. Es independiente de admin (D16): un administrador que no
// este en el grupo NO lo ve. El gate real vive en el backend; esto solo evita
// mostrar una puerta que da 403.

export const MODULOS = [
  {
    id: 'cxc',
    titulo: 'Cuentas por cobrar',
    descripcion: 'Clientes, ofertas, proyectos, cobros, pagos, proyeccion',
    icono: 'ti-cash',
    colorBorde: '#87B749',
    estado: 'activo',
    rutaPorDefecto: '/app/cxc/clientes',
    submenus: [
      { label: 'Clientes',       ruta: '/app/cxc/clientes' },
      { label: 'Ofertas',        ruta: '/app/cxc/ofertas-cliente' },
      { label: 'Proyectos',      ruta: '/app/cxc/proyectos' },
      { label: 'Cobros',         ruta: '/app/cxc/cobros-cliente' },
      { label: 'Pagos Cliente',  ruta: '/app/cxc/pagos-cliente' },
      { label: 'Proyeccion',     ruta: '/app/cxc/proyeccion-facturacion' },
      { label: 'Proyectos por Cerrar', ruta: '/app/cxc/proyectos-por-cerrar', admin: true }
    ]
  },
  {
    id: 'cxp',
    titulo: 'Cuentas por pagar',
    descripcion: 'Proveedores, cotizaciones, facturas, pagos proveedor',
    icono: 'ti-receipt',
    colorBorde: '#87B749',
    estado: 'activo',
    rutaPorDefecto: '/app/cxp/proveedores',
    submenus: [
      { label: 'Proveedores',      ruta: '/app/cxp/proveedores' },
      { label: 'Cotizaciones',     ruta: '/app/cxp/cotizaciones-proveedor' },
      { label: 'Facturas',         ruta: '/app/cxp/facturas-proveedor' },
      { label: 'Pagos Proveedor',  ruta: '/app/cxp/pagos-proveedor' }
    ]
  },
  {
    id: 'consultas',
    titulo: 'Consultas y reportes',
    descripcion: 'Proyectos por cliente, aging, rentabilidad, PDF',
    icono: 'ti-chart-bar',
    colorBorde: '#87B749',
    badge: 'Nuevo',
    estado: 'activo',
    rutaPorDefecto: '/app/consultas',
    submenus: [
      // Se llena en v37.1 con Q1, Q2, Q3
    ]
  },
  {
    id: 'rrhh',
    titulo: 'Recursos humanos',
    descripcion: 'Expediente digital, acciones de personal, documentos',
    icono: 'ti-users',
    colorBorde: '#87B749',
    badge: 'Nuevo',
    estado: 'activo',
    rol: 'rrhh',
    rutaPorDefecto: '/app/rrhh/expedientes',
    submenus: [
      { label: 'Expedientes',  ruta: '/app/rrhh/expedientes' },
      { label: 'Acciones',     ruta: '/app/rrhh/acciones' },
      { label: 'Catalogos',    ruta: '/app/rrhh/catalogos' }
    ]
  },
  {
    id: 'gastos',
    titulo: 'Gastos operativos',
    descripcion: 'Caja chica, tarjetas, reembolsos, viaticos',
    icono: 'ti-wallet',
    colorBorde: '#87B749',
    estado: 'activo',
    rutaPorDefecto: '/app/gastos/registro',
    submenus: [
      { label: 'Registro de gastos', ruta: '/app/gastos/registro' },
      { label: 'Recurrentes',        ruta: '/app/gastos/recurrentes' },
      { label: 'Aprobacion',         ruta: '/app/gastos/aprobacion' },
      { label: 'Catalogos',          ruta: '/app/gastos/catalogos', admin: true }
    ]
  },
  {
    id: 'configuracion',
    titulo: 'Configuracion',
    descripcion: 'Listas, tipologias, usuarios, parametros',
    icono: 'ti-settings',
    colorBorde: '#545454',
    estado: 'admin',
    rutaPorDefecto: '/app/configuracion',
    submenus: [
      { label: 'Configuracion', ruta: '/app/configuracion' }
    ]
  }
];
